<template>
  <div class="permissionEdit">
    <el-form
      :model="ruleForm"
      :rules="rules"
      ref="ruleForm"
      label-width="100px"
      class="demo-ruleForm"
    >
      <el-form-item label="是否有父级：">
        <el-switch v-model="isParentId"></el-switch>
      </el-form-item>
      <el-form-item
        label="菜单图标："
        prop="icon"
        style="margin-bottom: 20px"
        v-if="!isParentId"
      >
        <el-upload
          class="avatar-uploader"
          ref="upload"
          :action="imgaction"
          :show-file-list="false"
          accept=".jpg,.png,.jpeg,.svg"
          :on-success="handleAvatarSuccess"
          :before-upload="beforeAvatarUpload"
          :headers="{ Authorization: token }"
        >
          <img
            v-if="ruleForm.icon"
            :src="configFun.IMAGE_HOST + ruleForm.icon"
            class="avatar"
          />
          <i v-else class="el-icon-plus avatar-uploader-icon"></i>
        </el-upload>
      </el-form-item>
      <el-form-item
        v-if="isParentId"
        label="父级菜单："
        prop="parentId"
        style="margin-bottom: 15px"
      >
        <el-select
          v-model="ruleForm.parentId"
          style="width: 300px"
          placeholder="请选择父级菜单"
        >
          <el-option
            :label="item.title"
            :value="item.id"
            v-for="item in parentList"
            :key="item.id"
          ></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="菜单名称：" prop="title" style="margin-bottom: 15px">
        <el-input
          v-model="ruleForm.title"
          style="width: 300px"
          placeholder="请输入菜单名称"
        ></el-input>
      </el-form-item>
      <el-form-item label="菜单编码：" prop="code" style="margin-bottom: 10px">
        <el-input
          v-model="ruleForm.code"
          style="width: 300px"
          placeholder="请输入菜单编码"
        ></el-input>
      </el-form-item>
      <el-form-item label="是否开通：">
        <el-switch v-model="isOpen"></el-switch>
      </el-form-item>
      <el-form-item
        label="菜单路径："
        v-if="isOpen"
        prop="link"
        style="margin-bottom: 15px"
      >
        <el-input
          v-model="ruleForm.link"
          style="width: 300px"
          placeholder="请输入菜单路径"
        ></el-input>
      </el-form-item>
      <el-form-item
        label="提示信息："
        v-if="!isOpen"
        prop="toast"
        style="margin-bottom: 15px"
      >
        <el-input
          v-model="ruleForm.toast"
          style="width: 300px"
          placeholder="示例：暂未开通|联系客服 18116421007"
        ></el-input>
      </el-form-item>
      <el-form-item label="菜单类型：" prop="type" style="margin-bottom: 15px">
        <el-input
          v-model="ruleForm.type"
          style="width: 300px"
          placeholder="请填写菜单区分类型"
        ></el-input>
      </el-form-item>
      <el-form-item label="菜单排序：" prop="sort">
        <el-input-number
          v-model="ruleForm.sort"
          controls-position="right"
          @change="handleChange"
          :min="1"
          :max="100"
          style="width: 300px"
        ></el-input-number>
      </el-form-item>
      <el-form-item label="是否显示：">
        <el-switch v-model="ruleForm.isHome"></el-switch>
      </el-form-item>

      <el-form-item>
        <el-button type="primary" @click="submitForm('ruleForm')"
          >保存</el-button
        >
      </el-form-item>
    </el-form>
  </div>
</template>

<script>
import config from "../../../config";
export default {
  data() {
    return {
      imgaction: config.API_HOST + "/admin/common/upload",
      token: window.localStorage.getItem("token") || "",
      iconImg: "",
      configFun: config,
      isParentId: false,
      parentList: [],
      isType: "add",
      isOpen: true,
      ruleForm: {
        appType: null,
        code: "",
        icon: "",
        isHome: true,
        link: "",
        parentId: undefined,
        sort: 50,
        title: "",
        id: undefined,
        toast: "",
        type: "",
      },
      rules: {
        icon: [{ required: true, message: "请上传菜单图片", trigger: "blur" }],
        parentId: [
          { required: true, message: "请选择父级菜单", trigger: "change" },
        ],
        title: [
          {
            required: true,
            message: "请输入菜单名称",
            trigger: "blur",
          },
        ],
        code: [
          {
            required: true,
            message: "请输入功能编码",
            trigger: "blur",
          },
        ],
        link: [
          {
            required: true,
            message: "请输入菜单路径",
            trigger: "blur",
          },
        ],
        toast: [
          {
            required: true,
            message: "请输入提示信息",
            trigger: "blur",
          },
        ],
      },
    };
  },
  created() {
    let query = this.$route.query;
    this.ruleForm.appType = query.appType;
    this.isType = query.action;
    if (this.ruleForm.appType) {
      this.getPermissionList();
    }
    if (query.kv && query.action == "edit") {
      console.log(query.kv);
      this.load(query.kv);
    }
  },
  methods: {
    async load(id) {
      let q = {};
      const res = await $utils.api.load(
        `/admin/system/sysMobileFunctionMould/getInfo/${id}`,
        q,
        "GET"
      );
      if (res.code == 200) {
        const data = res.data;
        if (data.parentId) {
          this.isParentId = true;
          this.ruleForm.parentId = data.parentId;
        }
        this.ruleForm.id = data.id;
        this.ruleForm.icon = data.icon;
        this.ruleForm.title = data.title;
        this.ruleForm.isHome = data.isHome;
        this.ruleForm.link = data.link;
        this.ruleForm.sort = data.sort;
        this.ruleForm.code = data.code;
        this.ruleForm.toast = data.toast;
        this.ruleForm.type = data.type;
      }
      console.log(res);
    },
    async getPermissionList() {
      let q = { appType: this.ruleForm.appType };
      const res = await $utils.api.load(
        "/admin/system/sysMobileFunctionMould/list",
        q,
        "get"
      );
      if (res.code == 200) {
        this.parentList = res.rows;
      }
    },
    handleChange(value) {
      console.log(value);
    },
    handleAvatarSuccess(res, file) {
      this.iconImg = URL.createObjectURL(file.raw);
      if (res.code == 200) {
        this.ruleForm.icon = res.url;
      }
    },
    beforeAvatarUpload(file) {
      console.log(file);
      let isImg = true;
      const isJPG = file.type === "image/jpg";
      const isJPEG = file.type === "image/jpeg";
      const isPNG = file.type === "image/png";
      const isSVG = file.type === "image/svg+xml";
      const isLt2M = file.size / 1024 / 1024 < 2;

      if (!isJPG && !isJPEG && !isPNG && !isSVG) {
        this.$message.error("上传菜单图标只能是 JPG,JPEG,PNG,SVG 格式!");
        isImg = false;
      }
      if (!isLt2M) {
        this.$message.error("上传菜单图标大小不能超过 2MB!");
      }
      return isImg && isLt2M;
    },
    submitForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          console.log(this.ruleForm);

          $utils.api
            .load(
              "/admin/system/sysMobileFunctionMould",
              this.ruleForm,
              this.isType == "edit" ? "PUT" : "POST"
            )
            .then((res) => {
              if (res.code == 200) {
                $utils.toast.success("保存成功");
                $utils.url.go(-1);
              }
            });

          //   alert("submit!");
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
  },
};
</script>

<style scoped lang="less">
.permissionEdit {
  /deep/ .el-upload {
    border: 1px dashed #d9d9d9;
    border-radius: 6px;
    cursor: pointer;
    position: relative;
    overflow: hidden;
    width: 62px;
    height: 62px;
    box-sizing: border-box;
  }

  /deep/ .el-upload:hover {
    border-color: #409eff;
  }

  /deep/ .el-form-item {
    margin-bottom: 5px;
  }
  /deep/ .el-input__inner {
    height: 35px;
  }
  .avatar {
    width: 60px;
    height: 60px;
    border-radius: 6px;
  }
  .avatar-uploader {
    height: 62px;
  }
  .avatar-uploader-icon {
    font-size: 28px;
    color: #8c939d;
    width: 60px;
    height: 60px;
    line-height: 60px;
    text-align: center;
  }
}
</style>